<span class="status-badge" [ngClass]="badgeClass">
    <span class="badge-dot"></span>
    {{ label }}
</span>